import http from '../../../../http';

const orders = '/connex/services/orders';

export const api = {
  getFields: (entityRef, ruleType) => http.get(`${orders}/${entityRef}/master-data/rules/fields/${ruleType}`),
  getPricedProducts: entityRef => http.get(`${orders}/${entityRef}/master-data/rules/products`),
};
